<!-- 承载文字缩略 -->
<template>
  <span
    :class="titleClass"
    ellipsizeMode="tail"
    :numberOfLines="numberOfLines"
    :title="showTitle"
  >
    {{ showTitle }}
  </span>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  numberOfLines: {
    type: Number,
    default: 2,
  },
  disableEscape: {
    type: Boolean,
    default: true,
  },
});

const replaceEscapeChar = (str: string) => str.replace(/['"\\/\b\f\n\r\t]/g, '');

const showTitle = computed(
  () => (props.disableEscape ? replaceEscapeChar(props.title || '') : props.title),
);
const titleClass = computed(() => `title-ellipsis_${props.numberOfLines}`);
</script>

<style scoped>
.title-ellipsis_1 {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title-ellipsis_2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
